var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClaims(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8569 18.8572C17.8569 19.2361 17.7063 19.5995 17.4384 19.8674C17.1706 20.1352 16.8072 20.2858 16.4283 20.2858H3.57115C3.19226 20.2858 2.82891 20.1352 2.56099 19.8674C2.29309 19.5995 2.14258 19.2361 2.14258 18.8572V3.14293C2.14258 2.76404 2.29309 2.40068 2.56099 2.13277C2.82891 1.86487 3.19226 1.71436 3.57115 1.71436H12.8569L17.8569 6.71436V18.8572Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00377 7.81641C8.665 7.81641 8.39037 8.09105 8.39037 8.42982V10.155H6.66516C6.32639 10.155 6.05176 10.4297 6.05176 10.7685V12.762C6.05176 13.1008 6.32639 13.3754 6.66516 13.3754H8.39037V15.1006C8.39037 15.4394 8.665 15.714 9.00377 15.714H10.9973C11.3361 15.714 11.6107 15.4394 11.6107 15.1006V13.3754H13.3359C13.6747 13.3754 13.9494 13.1008 13.9494 12.762V10.7685C13.9494 10.4297 13.6747 10.155 13.3359 10.155H11.6107V8.42982C11.6107 8.09105 11.3361 7.81641 10.9973 7.81641H9.00377Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaims);
export default __webpack_public_path__ + "static/media/claims.58c404c1.svg";
export { ForwardRef as ReactComponent };